/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Go_BoardInputs */

const en_cmd_go_board = /** @type {(inputs: Cmd_Go_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to board`)
};

const de_cmd_go_board = /** @type {(inputs: Cmd_Go_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Board`)
};

/**
* | output |
* | --- |
* | "Go to board" |
*
* @param {Cmd_Go_BoardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_go_board = /** @type {((inputs?: Cmd_Go_BoardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Go_BoardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_go_board(inputs)
	return en_cmd_go_board(inputs)
});